const currencySymbols = [
  { currencyCode: 'EUR', currencySymbol: '€' },
  { currencyCode: 'ZAR', currencySymbol: 'R' },
];

export default {
  getByCurrencyCode: currencyCode => {
    let result = currencySymbols.find(
      x => x.currencyCode.toUpperCase() === currencyCode.toUpperCase(),
    );

    if (!result) {
      result = currencySymbols.find(x => x.currencyCode === 'EUR');
    }

    return result.currencySymbol;
  },
};
